<section 
    class="notifications-panel tw-z-[1000] tw-min-w-80 tw-max-w-[26rem] tw-overflow-hidden" 
    pFocusTrap
    [attr.aria-label]="'notifications.panel.ariaLabel' | transloco"
>

    @if (loading()) {
        <div class="tw-flex tw-items-center tw-justify-center tw-p-8">
            <p-progressSpinner
                strokeWidth="4"
                styleClass="p-progress-spinner-md"
            />
        </div>
    }

    @if (!loading()) {
        <ul class="tw-m-0 tw-p-0 tw-list-none tw-max-h-72 tw-overflow-y-auto">
            @for (notification of notifications(); track trackById(notification)) {
                <li class="notifications-panel__item tw-py-3 tw-px-4 tw-gap-2 tw-flex tw-items-center tw-self-stretch">
                    <p-button 
                    fluid 
                    [link]="true" 
                    class="tw-w-full notifications-panel__item-link"
                    (click)="redirect($event, notification)" 
                    (keydown.enter)="redirect($event, notification)"
                    data-test="navigation-notifications-panel-item"
                    >
                        <div class="tw-flex tw-justify-between tw-items-center tw-w-full">
                            <span class="tw-text-left tw-justify-self-auto tw-underline">
                                {{ [notification.action, notification.target, notification.stage] | notificationAction }}
                                {{ [notification.target, notification.payload, notification.action] | notificationName }}
                            </span>
                            <span class="notifications-panel__item-timestamp tw-justify-self-auto tw-whitespace-nowrap">
                                {{ notification.updated_at | amTimeAgo:now }}
                            </span>
                        </div>
                    </p-button>
                </li>
            }
            @if (notifications().length === 0) {
                <li class="notifications-panel__empty tw-flex tw-py-3 tw-px-4 tw-items-center tw-self-stretch tw-gap-2">
                    {{ 'notifications.panel.empty' | transloco }}
                </li>
            }
        </ul>

    }
    <div class="notifications-panel__footer tw-flex tw-flex-col tw-justify-center tw-items-center tw-self-stretch tw-py-4 tw-px-0">
        <p-button [link]="true" class="notifications-panel__view-all-btn" styleClass="tw-underline" (click)="viewAll()" (keydown.enter)="viewAll()" data-test="navigation-notifications-panel-view-all-button">
            {{ 'notifications.panel.viewAll' | transloco }}
        </p-button>
    </div>

</section>
